import { TARGET_GROUP } from '@decodo/utils';
import { useState } from 'react';

import { InputDropdownWithImage } from '@/components/atoms/InputDropdownWithImage';

import ScraperSelectedOption from './components/ScraperSelectedOption';
import ScraperTemplateSelectorListContent from './components/ScraperTemplateSelectorListContent';
import { getTargetByValue, targets } from './constants/targets';
import { useScraperTranslations } from './scraperTranslations';
import { useScraper } from './state/context';

export const ScraperTemplateSelector = () => {
  const { target, setTarget } = useScraper();
  const [selectedTag, setSelectedTag] = useState<TARGET_GROUP | ''>('');

  const { getTranslation } = useScraperTranslations();

  const handleOptionChange = (value: string) => {
    const target = getTargetByValue(value);

    if (!target) return;

    setTarget(target);
  };

  return (
    <InputDropdownWithImage
      name='target'
      renderListContent={({ handleSelect }) => (
        <ScraperTemplateSelectorListContent
          selectedTag={selectedTag as TARGET_GROUP}
          setSelectedTag={setSelectedTag}
          handleSelectTarget={(target) => handleSelect(target.targetKey)}
        />
      )}
      onOptionChange={handleOptionChange}
      value={target?.name}
      renderSelectedValue={ScraperSelectedOption}
      hasSearch={false}
      isDisabled={false}
      options={targets.map((target) => ({
        label: getTranslation(target.label) || '',
        value: target.name,
      }))}
      popoverProps={{ classNames: { childrenWrapper: 'mt-1' } }}
      classNames={{
        dropdown: 'overflow-y-hidden max-h-full',
        inputField: {
          root: 'dark:bg-gray-50 bg-transparent',
        },
      }}
    />
  );
};
